// extracted by mini-css-extract-plugin
export default {"container":"PalmReading_container__PCUSh","legendContainer":"PalmReading_legendContainer__Iniw0","palmImage":"PalmReading_palmImage__EyVsI"};